export default __webpack_public_path__ + "/images/year-of-the-tiger.jpg";